import { ChangeDetectionStrategy, Component, input, model } from '@angular/core';

import type { EsnSpatialNodeType } from '../../../shared/types/molecules';
import { IconComponent } from '../../atoms/icon/icon.component';

/**
 * A node card on the spatial hierarchy board. The root is outlined in orange with a live dot,
 * a floor can be collapsed, a device is a narrower card with neither, and a placeholder that only
 * exists in an upcoming version is a device-sized card with a dashed EchoBlue outline.
 */
@Component({
  selector: 'esn-spatial-node',
  imports: [IconComponent],
  templateUrl: './spatial-node.component.html',
  styleUrl: './spatial-node.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.esn-spatial-node-host--device]': 'type() === "device"',
    '[class.esn-spatial-node-host--placeholder]': 'type() === "placeholder"',
  },
})
export class SpatialNodeComponent {
  readonly type = input<EsnSpatialNodeType>('root');
  readonly label = input.required<string>();
  readonly subtitle = input<string | null>(null);

  /**
   * Open state of a floor node, toggled by its chevron.
   */
  readonly expanded = model(true);
}
